export const callCenterKeys = {
  // Root
  all: ['call-center'] as const,

  // Web-phone
  webPhone: {
    all: () => [...callCenterKeys.all, 'web-phone'] as const,
    contacts: () => [...callCenterKeys.webPhone.all(), 'contacts'] as const,
  }
} as const